<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listeParution.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button
              :class="{'button-access-no-permission':
                !checkPermissions(perms.parution.maj)}"
              @click="$router.push({name: 'm.presse.parution-add'})"
              class="button is-addOrEdit">
              {{ $t('listeParution.actions.add') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              :options="actions"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :elementsSelectionnes="getAllSelected().length > 0"
              @handleAction="handleActions"
              titleButton="general.button.apply">
            </selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-5 pdl-0 pdr-0">
            <b-input
              v-model="allCriteresRecherche.auto"
              :placeholder="$t('listeParution.actions.search')"
              type="search" icon="magnify">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label
                  :class="nombreCritere > 0 ? '' : 'is-invisible'"
                  class="has-text-weight-bold">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span
              @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="column is-narrow" v-if="isHSPExportActive">
          <exportExcelButton
            :perm="perms.parution.exporter"
            :query="exportExcelQuery">
          </exportExcelButton>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table v-if="startArrayRendering && mountedLoadingEnd"
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      class="stickyOnlyOnFirstTr"
      :ref="referenceTable" url="">
      <div slot="code" slot-scope="props">
        <a
          :class="{'text-access-no-permission': !checkPermissions(perms.parution.lecture)}"
          @click="checkPermissions(perms.parution.lecture)
            ? $router.push({ name: 'c.presse.parution', params: { id: props.row.id } })
            : showPopUp()"
          class="lien">
          {{props.row.code}}
        </a>
      </div>
      <div slot="nomParution" slot-scope="props">
        {{ props.row.nomParution }}
      </div>
      <div slot="produit" slot-scope="props">
        <router-link-blank
          :to="{
            name: 'c.bodac.catalogue-detailPresse',
            params: { id: props.row.produitId } }"
          :message="props.row.produit.reference + ' - ' + props.row.produit.libelle">
        </router-link-blank>
      </div>
      <div
        slot="dateEnvoiCF" slot-scope="props" class="is-cursor-pointer"
        :class="{'has-text-white': props.row.dateEnvoiCFDefinitif}"
        @click="actionValidationDate(typeDates.dateEnvoiCF, props.row)">
        {{ props.row.dateEnvoiCF | formatDate }}
      </div>
      <div
        slot="dateEnvoiBAT" slot-scope="props" class="is-cursor-pointer"
        :class="{'has-text-white': props.row.dateEnvoiBATDefinitif}"
        @click="actionValidationDate(typeDates.dateEnvoiBAT, props.row)">
        {{ props.row.dateEnvoiBAT | formatDate }}
      </div>
      <div
        slot="dateRemiseEltTech" slot-scope="props" class="is-cursor-pointer"
        :class="{'has-text-white': props.row.dateRemiseEltTechDefinitif}"
        @click="actionValidationDate(typeDates.dateRemiseEltTech, props.row)">
        {{ props.row.dateRemiseEltTech | formatDate }}
      </div>
      <div
        slot="dateParution" slot-scope="props" class="is-cursor-pointer"
        :class="{'has-text-white': props.row.dateParutionDefinitif}"
        @click="actionValidationDate(typeDates.dateParution, props.row)">
        {{ props.row.dateParution | formatDate }}
      </div>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="infoDispo" slot-scope="props">
          {{ props.row.ratioRestant + ' / ' + props.row.ratioCommercialisable }}
      </div>
      <div slot="disponibilite" slot-scope="props">
        <a @click="setOpenPopUpInfoVente(props.row)">
          <b-icon icon="circle"
                :type="getColorDisponibilite(props.row)"/>
        </a>
      </div>
      <div slot="edit" slot-scope="props">
        <router-link :to="{
          name: 'm.presse.parution-edit',
          params: { id: props.row.id } }">
          <b-icon
            :class="{'text-access-no-permission': !checkPermissions(perms.parution.maj)}"
            icon="pencil-box-outline" type="is-success">
          </b-icon>
        </router-link>
      </div>
      <div slot="bat" slot-scope="props" class="has-text-centered">
        <router-link-blank
          :class="{'text-access-no-permission': !checkPermissions(perms.parution.maj)}"
          :to="{
            name: 'm.presse.parution-bat',
            params: { parutionId: props.row.id },
          }"
          icon="eye"
          typeIcon="is-default">
        </router-link-blank>
      </div>
      <div slot="factures" slot-scope="props" class="has-text-centered">
        <router-link-blank
          :class="{
            'disabled': !asSomeFacture(props.row),
            'text-access-no-permission': !checkPermissions(perms.facture.lecture),
            }"
          :to="{
            name: 'l.bodac.factures-par-parution',
            params: { parutionId: props.row.id },
          }"
          icon="eye"
          typeIcon="is-default">
        </router-link-blank>
      </div>
      <div slot="commandesAFacturer" slot-scope="props" class="has-text-centered">
        <router-link-blank
          :to="{
            name: 'l.bodac.commandes-echeances-par-parution',
            params: { parutionId: props.row.id },
            }"
          :class="{
            'disabled': !checkCommandesAFacturerForParution(props.row.id),
            'text-access-no-permission': !checkPermissions(perms.commande.lecture),
          }"
          icon="eye"
          typeIcon="is-default">
        </router-link-blank>
      </div>
      <div slot="planMedia" slot-scope="props" class="has-text-centered">
        <router-link-blank
          :to="{
            name: 'l.presse.plan_media-par-parution',
            params: { parutionId: props.row.id },
            }"
          :class="{'text-access-no-permission': !checkPermissions(perms.planMedia.lecture)}"
          icon="eye"
          typeIcon="is-default">
        </router-link-blank>
      </div>
      <div slot="cheminFer" slot-scope="props" class="has-text-centered">
        <router-link-blank
          :to="{
            name: 'm.presse.chemin_fer',
            params: { parutionId: props.row.id },
          }"
          :class="{'text-access-no-permission': !checkPermissions(perms.cheminFer.lecture)}"
          icon="eye"
          typeIcon="is-default">
        </router-link-blank>
      </div>
      <div slot="archiver" slot-scope="props">
        <div
          @click="checkPermissions(perms.parution.supprimer)
          ? showPopUpArchivage(props.row) : showPopUp()"
          :class="{'disabled': props.row.lignesCommandes.length > 0}"
          class="is-cursor-pointer">
          <b-icon
            :icon="!props.row.archive ? 'archive' : 'archive-arrow-up'"
            :class="{'text-access-no-permission':
              !checkPermissions(perms.parution.supprimer)}"
            type="is-default">
          </b-icon>
        </div>
      </div>
      <div slot="delete" slot-scope="props">
        <div
          class="is-cursor-pointer"
          @click="checkPermissions(perms.parution.supprimer)
          ? showPopUpDelete(props.row.id) : showPopUp()"
          :class="{'disabled': props.row.lignesCommandes.length > 0}">
          <b-icon
            :class="{'text-access-no-permission':
              !checkPermissions(perms.parution.supprimer)}"
            type="is-danger" icon="delete-forever">
          </b-icon>
        </div>
      </div>
      <div slot="edition" slot-scope="props">
        <div
          class="is-cursor-pointer"
          @click="checkPermissions(perms.parution.editer)
            ? actionMassEdtionParution(props.row) : showPopUp()">
          <b-icon
            :class="{'text-access-no-permission': !checkPermissions(perms.parution.editer)}"
            type="is-primary" icon="file-download">
          </b-icon>
        </div>
      </div>
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template slot="child_row" slot-scope="props">
        <pages-parution
          :parution="props.row"
          is-detail
          is-child-row/>
      </template>
    </v-server-table>
    <div v-show="showFiltre" class="componentBrief">
      <filtre-parution
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"
        ref="filtreParution"/>
    </div>
    <b-modal
      v-model="popUpGeneration"
      @close="() => { isPopUpDuplication = false }"
      class="modal"
      has-modal-card>
      <pop-up-generation
        :items="getAllSelected()"
        :is-duplication="isPopUpDuplication"
        @reload="recherche()">
      </pop-up-generation>
    </b-modal>
    <b-modal
      v-model="openPopUpInfoVente"
      class="modal"
      has-modal-card>
      <info-vente :lignes-commande="lignesCommande" :parution="parution"></info-vente>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="{}"
        :choiceEdition="listeChoiceEdition"
        @editionChoose="editionParution">
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="popUpArchivage"
             has-modal-card
             class="modal" @close="parutionToArchive = null">
      <popUpPrevention v-if ="parutionToArchive"
             :messHeader="$t(baseTradArchiveComputed(parutionToArchive.archive) + '.title')"
             :cancel="$t('general.non')"
             :validate="$t('general.oui')"
             @no="popUpArchivage = false"
             @yes="archiverProduit(parutionToArchive.archive)"/>
    </b-modal>
    <b-modal v-model="popUpDelete"
            has-modal-card
            class="modal">
      <pop-up-prevention :mess-header="parutionsIds.length > 1
                          ? this.$t('listeParution.suppression.titleMulti')
                          : this.$t('listeParution.suppression.title')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         :is-error-popup="errorPopUp"
                         :messages-popup="messagesPopup"
                         @yes="deleteParution"
                         @no="popUpDelete = false">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-model="popUpValidationDateParution"
      has-modal-card
      class="modal">
      <pop-up-validation-date-parution
        :type-date="typeDateSelected"
        :parution="parutionSelected"
        @is-update="recherche"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { PARUTION, PLAN_MEDIA, CHEMIN_FER } from '@/configuration/presse/permissionsPresseConf';
import { FACTURES, COMMANDES } from '@/configuration/permissionsBodacConf';
import breadcrumb from '@/components/general/breadcrumb';
import selecteurAction from '@/components/general/selecteurAction';
import filtreParution from '@/components/presse/parution/filtreParution';
import PopUpGeneration from '@/components/presse/parution/p_generationParutions';
import PopUpValidationDateParution from '@/components/presse/parution/p_validationDateParution';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import validationParution from '@/services/presse/parution/validationParution';
import TableItemsInView from '@/components/general/TableItemsInView';
import PagesParution from '@/components/presse/parution/pagesParution';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import {
  ACTION_GENERATION_PARUTIONS,
  ACTION_DUPLICATION_PARUTIONS,
  LISTE_CHOICE_EDITION_PARUTION,
  TYPE_DATES,
  TYPE_EDITION_REALISE,
  TYPE_EDITION_RELEVE_DE_PUB,
  TYPE_EDITION_RELEVE_DE_PUB_RAPPROCHE,
  TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE,
  TYPE_EDITION_PARUTION_REPORTING,
  EXPORT_EXCEL_PARUTION,
  SPECIFIQUE_HSP,
} from '@/configuration/presse/parution/parutionConfig';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import inProgress from '@/services/general/inProgress';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { get } from '@/api/produit/produitPresse';
import edition from '@/api/edition';
import messageErreur from '@/services/general/messageErreur';
import infoVente from '@/components/presse/parution/p_infoVente';
import {
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  TYPE_COMMANDE, SENS_VENTE,
} from '@/configuration/devisConf';
import { ACTION_MASS_DELETE, ACTION_MASS_EDITION } from '@/configuration/general/actionsConf';
import popUpEdition from '@/components/factures/p_edition';
import formatDateIso from '@/services/general/formatIsoDate';
import popUpPrevention from '@/components/general/popUpPrevention';
import { archiver, deleteParution } from '@/api/presse/parution';
import getAllCommandeAFacturer from '@/api/commandeAFacturer';
import genererCritereRechercheCommandeAFacturer from '@/services/devisCommandes/genererCritereRechercheCommandeAFacturer';
import messageSucces from '@/services/general/messageSucces';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LISTE_PARUTION } from '@/configuration/general/referenceTableConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { columnsSplice } from '@/services/general/columns';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Parution = createNamespacedHelpers('parution');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    breadcrumb,
    selecteurAction,
    filtreParution,
    TableItemsInView,
    PagesParution,
    infoVente,
    popUpEdition,
    PopUpGeneration,
    popUpPrevention,
    PopUpValidationDateParution,
    routerLinkBlank,
    parametrageTable,
    exportExcelButton,
  },
  data() {
    return {
      typeDates: TYPE_DATES,
      perms: {
        parution: PARUTION,
        facture: FACTURES,
        commande: COMMANDES,
        planMedia: PLAN_MEDIA,
        cheminFer: CHEMIN_FER,
      },
      listeChoiceEdition: LISTE_CHOICE_EDITION_PARUTION,
      showFiltre: false,
      popUpGeneration: false,
      isPopUpDuplication: false,
      loadingComponent: null,
      popUpArchivage: false,
      popUpValidationDateParution: false,
      typeDateSelected: null,
      parutionSelected: null,
      parutionsIds: [],
      parutionToArchive: null,
      openPopUpInfoVente: false,
      lignesCommande: [],
      commandesAFacturer: [],
      popUpEdition: false,
      errorPopUp: false,
      messagesPopup: [],
      popUpDelete: false,
      permsParution: PARUTION,
      parution: null,
      actions: [
        { action: ACTION_GENERATION_PARUTIONS, translation: 'listeParution.actions.generationParutions' },
        { action: ACTION_DUPLICATION_PARUTIONS, translation: 'listeParution.actions.duplicationParutions' },
        { action: ACTION_MASS_EDITION, translation: 'listeParution.actions.editionMasse' },
        { action: ACTION_MASS_DELETE, translation: 'listeParution.actions.suppressionMasse' },
      ],
      startArrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_LISTE_PARUTION,
      resultPerPage: RESULTS_PER_PAGE,
      constantes: {
        TYPE_EDITION_PARUTION_REPORTING,
        TYPE_PDF,
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parution.mapGetters({
      parutions: 'items',
      total: 'total',
      allCriteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    isHSPExportActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.HSPParutionExport.key);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_PARUTION,
        typeExport: SPECIFIQUE_HSP,
        filtres: this.lastPayload,
      };
    },
    breadcrumb() {
      return [
        { title: this.$t('listeParution.breadcrumb.home'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeParution.breadcrumb.liste'), route: { name: 'l.presse.parution' }, isActive: true },
      ];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'periodeDateEnvoiCF', 'periodeDateEnvoiBAT', 'periodeDateRemiseEltTech', 'periodeDateParution'];
      let nbCritere = calculNombreCritere(this.allCriteresRecherche, banCritereKey);
      if (this.allCriteresRecherche.periodeDateEnvoiCF) {
        nbCritere += this.allCriteresRecherche.periodeDateEnvoiCF.dateDebut ? 1 : 0;
      }
      if (this.allCriteresRecherche.periodeDateEnvoiBAT) {
        nbCritere += this.allCriteresRecherche.periodeDateEnvoiBAT.dateDebut ? 1 : 0;
      }
      if (this.allCriteresRecherche.periodeDateRemiseEltTech) {
        nbCritere += this.allCriteresRecherche.periodeDateRemiseEltTech.dateDebut ? 1 : 0;
      }
      if (this.allCriteresRecherche.periodeDateParution) {
        nbCritere += this.allCriteresRecherche.periodeDateParution.dateDebut ? 1 : 0;
      }
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeParution.tab.code'),
          numParution: this.$i18n.t('listeParution.tab.numParution'),
          nomParution: this.$i18n.t('listeParution.tab.nomParution'),
          produit: this.$i18n.t('listeParution.tab.produit'),
          dateEnvoiCF: this.$i18n.t('listeParution.tab.dateEnvoiCF'),
          dateEnvoiBAT: this.$i18n.t('listeParution.tab.dateEnvoiBAT'),
          dateRemiseEltTech: this.$i18n.t('listeParution.tab.dateRemiseEltTech'),
          dateParution: this.$i18n.t('listeParution.tab.dateParution'),
          disponibilite: '',
          infoDispo: this.$i18n.t('listeParution.tab.rav'),
          bat: this.$i18n.t('listeParution.tab.bat'),
          factures: this.$i18n.t('listeParution.tab.factures'),
          commandesAFacturer: this.$i18n.t('listeParution.tab.commandesAFacturer'),
          planMedia: this.$i18n.t('listeParution.tab.planMedia'),
          cheminFer: this.$i18n.t('listeParution.tab.cheminFer'),
          edition: '',
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        cellClasses: {
          dateEnvoiCF: [{
            class: 'has-background-success',
            condition: (row) => row.dateEnvoiCFDefinitif,
          }],
          dateEnvoiBAT: [{
            class: 'has-background-success',
            condition: (row) => row.dateEnvoiBATDefinitif,
          }],
          dateRemiseEltTech: [{
            class: 'has-background-success',
            condition: (row) => row.dateRemiseEltTechDefinitif,
          }],
          dateParution: [{
            class: 'has-background-success',
            condition: (row) => row.dateParutionDefinitif,
          }],
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.allCriteresRecherche);
          data.query.produitsId = data.query.produitsId.map((el) => el.id);
          data.query.societeId = this.societeActiveId;
          if (data.query.periodeDateParution.dateDebut) {
            data.query.periodeDateParution.dateDebut = formatDateIso(
              data.query.periodeDateParution.dateDebut,
            );
          }
          if (data.query.periodeDateParution.dateFin) {
            data.query.periodeDateParution.dateFin = formatDateIso(
              data.query.periodeDateParution.dateFin,
            );
          }
          return this.loadParutionsAvecDispo(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.parutions,
            count: this.total,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          disponibilite: 'colonneSelected',
          infoDispo: 'colonneDispoParution',
        },
        sortable: ['code', 'numParution', 'nomParution', 'dateEnvoiCF', 'dateEnvoiBAT', 'dateRemiseEltTech', 'dateParution'],
      };
    },
    columns() {
      const coluumns = [
        'selected', 'produit', 'code', 'numParution', 'nomParution', 'dateEnvoiBAT', 'dateEnvoiCF', 'dateRemiseEltTech', 'dateParution',
        'infoDispo', 'disponibilite', 'planMedia', 'bat', 'cheminFer', 'commandesAFacturer', 'factures',
        'edition', 'edit', 'archiver', 'delete',
      ];
      if (!this.modulePlanMediaActive) {
        columnsSplice(coluumns, 'planMedia');
      }
      return coluumns;
    },
    iconSelectTotal() {
      if (this.allParutionSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allParutionSelected() {
      return this.getAllSelected().length === this.parutions.length
        && this.parutions.length > 0;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parution.mapActions({
      loadParutionsAvecDispo: 'loadParutionsAvecDispo',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    showPopUpArchivage(parutionToArchive) {
      this.popUpArchivage = true;
      this.parutionToArchive = parutionToArchive;
    },
    showPopUpDelete(id) {
      this.parutionsIds = [id];
      this.errorPopUp = false;
      this.popUpDelete = true;
    },
    async deleteParution() {
      this.messagesPopup = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteParution(this.parutionsIds);
        this.popUpDelete = false;
        messageSucces(this.parutionsIds.length > 1
          ? this.$t('listeParution.suppression.sucess.parutionMulti')
          : this.$t('listeParution.suppression.sucess.parutionDelete'));
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.errorPopUp = true;
          validationParution(e.response, this.messagesPopup);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    baseTradArchiveComputed(etat) {
      if (!etat) {
        return 'listeParution.popUpArchivage';
      }
      return 'listeParution.popUpDesarchivage';
    },
    actionValidationDate(typeDate, parution) {
      this.parutionSelected = parution;
      this.typeDateSelected = typeDate;
      this.popUpValidationDateParution = true;
    },
    async archiverProduit(etat) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.parutionToArchive.id, etat);
        loadingComponent.close();
        this.popUpArchivage = false;
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    asSomeFacture(parution) {
      return parution.lignesCommandes.some(
        ligne => [ETAT_FACTURE, ETAT_FACTURE_PARTIELLEMENT].includes(ligne.devisCommandeEtat)
          && ligne.hasEcheancierLigneFacture,
      );
    },
    async editionParution(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const editionInput = {
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: {
            societeId: this.societeActiveId,
          },
        };
        switch (donnees.typeDonnee) {
          case TYPE_EDITION_REALISE:
          case TYPE_EDITION_RELEVE_DE_PUB:
          case TYPE_EDITION_RELEVE_DE_PUB_RAPPROCHE:
            editionInput.ids = this.parutions.filter((el) => {
              return el.selected;
            }).map((el) => { return el.produitId; });
            editionInput.ids = editionInput.ids.filter((x, i) => editionInput.ids.indexOf(x) === i);
            editionInput.parametresAdditionnels.parutionsIds = this.parutions.filter((el) => {
              return el.selected;
            }).map((el) => { return el.id; }).join(', ');
            if (this.allCriteresRecherche.periodeDateParution.dateDebut
              && this.allCriteresRecherche.periodeDateParution.dateFin) {
              editionInput.parametresAdditionnels.dateDebut = this.allCriteresRecherche
                .periodeDateParution.dateDebut;
              editionInput.parametresAdditionnels.dateFin = this.allCriteresRecherche
                .periodeDateParution.dateFin;
            }
            break;
          case TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE:
            editionInput.ids = this.parutions.filter((el) => {
              return el.selected;
            }).map((el) => { return el.id; });
            editionInput.parametresAdditionnels.sansPageVide = 'True';
            break;
          case TYPE_EDITION_PARUTION_REPORTING:
            editionInput.ids = this.parutions.filter(el => el.selected).map((el) => el.id);
            editionInput.parametresAdditionnels.filter = JSON.stringify(
              generalTransformer({
                ...this.lastPayload,
                query: {
                  ...this.lastPayload.query,
                  parutionsIds: editionInput.ids,
                },
              }));
            break;
          default:
            editionInput.ids = this.parutions.filter((el) => {
              return el.selected;
            }).map((el) => { return el.id; });
            break;
        }
        const response = await edition(editionInput);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    setOpenPopUpInfoVente(parution) {
      this.lignesCommande = parution.lignesCommandes.filter((ligne) => {
        return ligne.devisCommandeType === TYPE_COMMANDE;
      });
      this.parution = parution;
      this.openPopUpInfoVente = true;
    },
    getColorDisponibilite(parution) {
      if (parution.ratioVendu === 0) return 'is-success';
      if (parution.ratioRestant <= 0) return 'is-danger';
      return 'is-warning';
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    getAllSelected() {
      return this.parutions.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const state = !this.allParutionSelected;
      this.parutions.forEach(item => {
        item.selected = state;
      });
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
      this.getCommandesAFacturer();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreParution.initializeFiltre();
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreParution.initializeFiltre();
      this.$refs.filtreParution.viderCritere();
      this.$refs.filtreParution.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    actionMassEdtionParution(parution) {
      this.parutions.forEach(p => {
        if (p.id === parution.id) p.selected = true;
        else p.selected = false;
      });
      this.popUpEdition = true;
    },
    handleActions(action) {
      switch (action) {
        case ACTION_GENERATION_PARUTIONS:
          this.popUpGeneration = true;
          break;
        case ACTION_DUPLICATION_PARUTIONS:
          this.popUpGeneration = true;
          this.isPopUpDuplication = true;
          break;
        case ACTION_MASS_EDITION:
          if (this.checkPermissions(this.permsParution.editer)) {
            this.popUpEdition = true;
          } else this.showPopUp();
          break;
        case ACTION_MASS_DELETE:
          if (this.checkPermissions(this.permsParution.supprimer)) {
            this.popUpDelete = true;
            this.errorPopUp = false;
            this.parutionsIds = this.parutions.filter((el) => {
              return el.selected;
            }).map((el) => { return el.id; });
          } else this.showPopUp();
          break;
        default:
          break;
      }
    },
    async getCommandesAFacturer() {
      if (!this.parutions.length) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const query = genererCritereRechercheCommandeAFacturer(true);
        query.parutionsIds = this.parutions.map(parution => parution.id);
        query.societeId = this.societeActiveId;
        query.agencesIds = this.agencesSelectionnees.map((agence) => agence.agenceId);
        query.sens = SENS_VENTE;
        this.commandesAFacturer = (
          await getAllCommandeAFacturer({ query }, 99999)).data.result.items;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    checkCommandesAFacturerForParution(parutionId) {
      if (!this.commandesAFacturer.length) return false;
      const commandeAFacturer = this.commandesAFacturer
        .filter(cmd => cmd.lignesCommande
          .map(ligne => ligne.parutionId));
      const lignesCommandes = commandeAFacturer
        .map(c => c.lignesCommande)
        .reduce((a, b) => a.concat(b), [])
        .filter(l => l.parutionId === parutionId);
      const referencesRegroupement = lignesCommandes
        .filter(l => l.referenceRegroupement)
        .map(l => l.referenceRegroupement);
      const lignesEnfants = this.commandesAFacturer
        .map(c => c.lignesCommande)
        .reduce((a, b) => a.concat(b), [])
        .filter(le => referencesRegroupement.includes(le.referenceRegroupement));
      const referencesEcheancier = lignesEnfants
        .filter(l => l.referenceEcheancier)
        .map(l => l.referenceEcheancier);
      const ligneEchAFacturer = commandeAFacturer.map(c => c.echeancesLignes)
        .reduce((a, b) => {
          return a.concat(b);
        }, [])
        .filter(echLigne => !echLigne.facturationFaite
        && referencesEcheancier.includes(echLigne.referenceEcheancier));

      return ligneEchAFacturer.length > 0;
    },
  },

  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },

  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche);
      this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.HSPParutionExport.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
      this.setInformationPage(this.$t('pagePresse.parution.liste'));
      if (this.$route.params.produitId) {
        this.allCriteresRecherche.produitsId = [(
          await get(this.$route.params.produitId)).data.result];
      }
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
